import { GESTION_OPERATIVA_SET_USED_TAKE_AMOUNT_USADO, GESTION_OPERATIVA_USED_TAKE_AMOUNT_USADO_ERROR, GESTION_OPERATIVA_SET_IS_MODIFIED } from './constants'

export function setUsedTakeAmount(takeAmount,patente) {
  return (dispatch, getState) => {
    const { gestionOperativa } = getState();
    const {sale} = gestionOperativa;
    const takingCars = sale.Taking_cars;
    let modifiedTakingCars = takingCars;

    const currentCarIndex = takingCars?.findIndex(item => item.license_plate === patente)
    const currentCarData = takingCars[currentCarIndex]

    if(currentCarData.updatedTakePrice === takeAmount)
      return;

    if (takeAmount < 0) {
      dispatch({
        type: GESTION_OPERATIVA_USED_TAKE_AMOUNT_USADO_ERROR,
        data: {
          error: true,
          patente: patente,
          message: `El monto ingresado no puede ser menor a cero.`
        }
      })
    } else {
      const isRevertedToOriginal = Number(takeAmount) === Number(currentCarData.original_price)

      if (isRevertedToOriginal) {
        modifiedTakingCars[currentCarIndex].updatedTakePrice = null
        modifiedTakingCars[currentCarIndex].updatedTakePriceWasModified = false
      } else {
        modifiedTakingCars[currentCarIndex].updatedTakePrice = takeAmount
        modifiedTakingCars[currentCarIndex].updatedTakePriceWasModified = true
      }

      modifiedTakingCars[currentCarIndex].final_take_price = takeAmount
      modifiedTakingCars[currentCarIndex].take_improvement_amount = 0
      
      // dispatch(
        dispatch({
          type: GESTION_OPERATIVA_SET_USED_TAKE_AMOUNT_USADO,
          data: modifiedTakingCars
        })
        dispatch({
          type: GESTION_OPERATIVA_SET_IS_MODIFIED,
          data: true
        })
      // )
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case GESTION_OPERATIVA_SET_USED_TAKE_AMOUNT_USADO:
      return {
        ...state,
        takeAmountError: null,
        sale: {
          ...state.sale,
          Taking_cars: action.data
        }
      }
    case GESTION_OPERATIVA_USED_TAKE_AMOUNT_USADO_ERROR:
      return {
        ...state,
        takeAmountError: action.data,
      }
    default:
      return state
  }
}